import { toIndianNumber } from "~/utils/number";
import { CoinsTransactionsModal } from "../coins_transactions_modal";
import { useModal } from "../modal";
import { addCircularFilledBlack, coinIcon } from "~/assets/assets";
import { Show } from "solid-js";
import { RedeemCodeModal } from "../redeem_code_modal";
import { Spacer } from "~/widgets/spacer";
import { useWebStoreContext } from "~/context/webstore_context";
import { useLocation } from "@solidjs/router";

// this component uses the webstore context to refresh the coins balance
// hence it should be used only in the webstore context (routes inside (web_store) folder)
export function HeaderCoinsPill(props: {
  coins: number;
  userName?: string;
  mode: string;
  isRedeemCodeEnabled?: boolean;
}) {
  const { openModal, setIsModalOn, updateModalContentGetter } = useModal()!;
  const { refreshV4HomePage, isHeaderScrolledOut } = useWebStoreContext();
  const location = useLocation();
  const isHomePage = () => location.pathname === '/';

  const showRedeemButton = () => {
    const redeemEnabled = props.mode === "rnr" && (props.isRedeemCodeEnabled ?? true);
    if (!redeemEnabled) return false;
    return isHomePage() && !isHeaderScrolledOut();
  };

  function openCoinsTransactionsModal(event: MouseEvent) {
    event.stopPropagation();
    updateModalContentGetter(() => {
      return (
        <CoinsTransactionsModal
          balance={props.coins ?? 0}
          userName={props.userName ?? ""}
          enableRedeemCode={props.isRedeemCodeEnabled ?? true}
          title={props.mode === "rnr" ? "Your coins" : undefined}
          subtitle={
            props.mode === "rnr"
              ? "Use it to get gift cards of your choice"
              : undefined
          }
          refreshV4HomePage={refreshV4HomePage}
        />
      );
    });

    setIsModalOn(true);
  }

  return (
    <div>
      <Show when={showRedeemButton()}>
        <div
          class="flex h-9 cursor-pointer items-center justify-center gap-0.5 rounded-[36px] bg-basePrimaryDark py-[18px] pl-1.5 pr-3"
          onClick={() => {
            openModal(() => {
              return (
                <RedeemCodeModal
                  userName={props.userName ?? ""}
                  refreshV4HomePage={refreshV4HomePage}
                />
              );
            }, "md:w-[416px] h-fit");
          }}
        >
          <img src={addCircularFilledBlack} alt="add code" />
          <p class="text-center text-mediumBold text-baseTertiaryLight">
            Redeem code
          </p>
        </div>
      </Show>
      <Show when={!showRedeemButton()}>
        <div
          onClick={openCoinsTransactionsModal}
          class={`hidden cursor-pointer items-center rounded-[50px] border-[0.5px] border-[#C0C0C0] bg-baseTertiaryLight pl-2 darkTheme:border-[#313538] darkTheme:bg-[#212427]  lg:flex ${props.mode === "rnr" && (props.isRedeemCodeEnabled ?? true)
            ? "pr-[6px]"
            : "pr-3"
            }`}
        >
          <div class="flex items-center justify-center gap-1 py-2">
            <img src={coinIcon} alt="" class="h-5 w-5" />
            <div
              class={`text-f12w700 text-textDark ${props.mode != "rnr" ? "pr-1" : ""}`}
            >
              {toIndianNumber(props.coins ?? 0)}
            </div>
          </div>
          <Show
            when={props.mode === "rnr" && (props.isRedeemCodeEnabled ?? true)}
          >
            <div
              class="flex cursor-pointer items-center rounded-e-2xl pl-1"
              onClick={() => {
                openModal(() => {
                  return (
                    <RedeemCodeModal
                      userName={props.userName ?? ""}
                      refreshV4HomePage={refreshV4HomePage}
                    />
                  );
                }, "md:w-[416px] h-fit");
              }}
            >
              <img src={addCircularFilledBlack} alt="add code" />
            </div>
          </Show>
        </div>
        <div
          onClick={openCoinsTransactionsModal}
          class={`flex h-8 cursor-pointer items-center rounded-[50px] border-[0.5px] border-[#C0C0C0] bg-baseTertiaryLight py-[7px] pl-[8.4px]  lg:hidden ${props.mode === "rnr" && (props.isRedeemCodeEnabled ?? true) ? "pr-[6.4px]" : "pr-3"}`}
          style={{
            "box-shadow": "0px 2px 11px 0px rgba(0, 0, 0, 0.05)",
          }}
        >
          <img src={coinIcon} alt="" class="h-4 w-4" />
          <Spacer width={2.4} />
          <div class="text-f12w700 text-textDark">
            {toIndianNumber(props.coins ?? 0)}
          </div>
          <Show
            when={props.mode === "rnr" && (props.isRedeemCodeEnabled ?? true)}
          >
            <div
              class="flex cursor-pointer items-center rounded-e-2xl pl-1"
              onClick={() => {
                openModal(() => {
                  return (
                    <RedeemCodeModal
                      userName={props.userName ?? ""}
                      refreshV4HomePage={refreshV4HomePage}
                    />
                  );
                }, "md:w-[416px] h-fit");
              }}
            >
              <img src={addCircularFilledBlack} alt="add code" />
            </div>
          </Show>
        </div>
      </Show>
    </div>
  );
}
